window.addEventListener('DOMContentLoaded',function(){
    // $('.mege-menu-custom-lt-item-top').on('click',function(){
    //     $(this).toggleClass('active');
    //     $(this).parent().find('.mege-menu-custom-lt-item-content').slideToggle(300);
    // })

    // $('#menu-drawer-panel-main .menu-level-one:first-child .menu-level-one-title').click();
})